import { render, staticRenderFns } from "./BelposhtaTable.vue?vue&type=template&id=258604ce&scoped=true"
import script from "./BelposhtaTable.vue?vue&type=script&lang=js"
export * from "./BelposhtaTable.vue?vue&type=script&lang=js"
import style0 from "./BelposhtaTable.vue?vue&type=style&index=0&id=258604ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258604ce",
  null
  
)

export default component.exports